import React from "react";
import "./image.css";

export function Image(asset) {
  console.log(asset.asset.sources[0].src);
  return (
    <div className="image-container" role="document">
      <div>
        <img
          alt="Preview image for asset"
          className="modal-image"
          src={
            asset.asset.sources &&
            asset.asset.sources.length &&
            asset.asset.sources[0].src
          }
        />
      </div>
      <div className="bottom-panel">
          <a href={asset.asset.sources[0].src} download>Download</a>
      </div>
    </div>
  );
}
